import { render, staticRenderFns } from "./top-title.vue?vue&type=template&id=b901fa38&lang=pug&"
import script from "./top-title.vue?vue&type=script&lang=js&"
export * from "./top-title.vue?vue&type=script&lang=js&"
import style0 from "./top-title.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports